import { injectGlobal } from 'styled-components';
import reset from './reset';
import slick from './slick';

const baseStyles = () => injectGlobal`
  ${reset}
  ${slick}
  a {
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .zEWidget-launcher {
    display: none;
  }
`

export default baseStyles;



// WEBPACK FOOTER //
// ./src/layouts/baseStyles.js